(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-jawline"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var root = document.querySelector('.adv');
  if (!root) return;

  /* ── FAQ accordion ── */
  var faqItems = root.querySelectorAll('.adv__faq-item');
  faqItems.forEach(function(item) {
    var trigger = item.querySelector('.adv__faq-trigger');
    if (!trigger) return;
    trigger.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      faqItems.forEach(function(i) {
        i.classList.remove('is-open');
        var t = i.querySelector('.adv__faq-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Bundle plan selector ── */
  var planBtns = root.querySelectorAll('.adv__plan');
  var priceEl = root.querySelector('#adv-price');
  var compareEl = root.querySelector('#adv-compare');
  var qtyInput = root.querySelector('#adv-qty');
  var singlePrice = priceEl ? priceEl.textContent : '';
  var singleCompare = compareEl ? compareEl.textContent : '';

  planBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      planBtns.forEach(function(b) { b.classList.remove('adv__plan--active'); });
      btn.classList.add('adv__plan--active');
      var qty = parseInt(btn.dataset.qty, 10) || 1;
      if (qtyInput) qtyInput.value = qty;

      if (qty > 1) {
        if (priceEl) priceEl.textContent = btn.dataset.displayPrice || singlePrice;
        if (compareEl) {
          var orig = btn.dataset.originalPrice;
          if (orig) { compareEl.textContent = orig; compareEl.style.display = ''; }
          else { compareEl.style.display = 'none'; }
        }
      } else {
        if (priceEl) priceEl.textContent = singlePrice;
        if (compareEl) {
          if (singleCompare) { compareEl.textContent = singleCompare; compareEl.style.display = ''; }
          else { compareEl.style.display = 'none'; }
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {

  var grid    = document.querySelector('[data-bna-grid]');
  var dots    = document.querySelectorAll('[data-bna-dots] .bna__dot');
  var btnPrev = document.querySelector('[data-bna-prev]');
  var btnNext = document.querySelector('[data-bna-next]');

  if (!grid) return;

  var cards      = Array.from(grid.querySelectorAll('.bna__card'));
  var cardCount  = cards.length;
  var currentIdx = 0;

  function getVisibleCount() {
    return window.innerWidth > 768 ? 3 : 1;
  }

  function scrollTo(idx) {
    var visible = getVisibleCount();
    var maxIdx  = Math.max(0, cardCount - visible);
    currentIdx  = idx > maxIdx ? 0 : (idx < 0 ? maxIdx : idx);
    if (cards[currentIdx]) {
      grid.scrollTo({ left: cards[currentIdx].offsetLeft - (window.innerWidth > 768 ? 0 : (grid.offsetWidth - cards[currentIdx].offsetWidth) / 2), behavior: 'smooth' });
    }
    updateDots();
  }

  function updateDots() {
    dots.forEach(function(d, i) { d.classList.toggle('bna__dot--active', i === currentIdx); });
  }

  if (btnPrev) btnPrev.addEventListener('click', function() { scrollTo(currentIdx - 1); });
  if (btnNext) btnNext.addEventListener('click', function() { scrollTo(currentIdx + 1); });

  // Sync dots on manual scroll
  grid.addEventListener('scroll', function() {
    if (!cards[0]) return;
    var cardW = cards[0].offsetWidth + 24;
    var idx   = Math.round(grid.scrollLeft / cardW);
    if (idx !== currentIdx) { currentIdx = idx; updateDots(); }
  }, { passive: true });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
(function () {

  // ── Staggered row reveal ──────────────────────────────────────────────
  var rows  = Array.from(document.querySelectorAll('.cmp__row'));
  var tbody = document.querySelector('[data-cmp-tbody]');

  if (!tbody) return;

  var triggered = false;

  var observer = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting || triggered) return;
    triggered = true;

    rows.forEach(function(row, i) {
      setTimeout(function() {
        row.classList.add('cmp--row-visible');
      }, i * 70);
    });

    observer.disconnect();
  }, { threshold: 0.1 });

  observer.observe(tbody);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
(function () {
  var overlay   = document.getElementById('ssc-popup-overlay');
  if (!overlay) return;

  var closeBtn  = overlay.querySelector('.ssc-popup-close');
  var form      = document.getElementById('ssc-popup-form');
  var statusEl  = document.getElementById('ssc-popup-status');

  var KL_COMPANY  = 'Rv4p9M';
  var KL_LIST     = 'RaE7KF';
  var STORAGE_KEY = 'sk_epop_v9';

  function getState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch(e) { return {}; }
  }
  function setState(patch) {
    var s = getState();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch(e) {}
  }

  function openPopup() {
    if (overlay.classList.contains('ssc-popup--open')) return;
    overlay.classList.add('ssc-popup--open');
    document.body.style.overflow = 'hidden';
    setState({ lastShown: Date.now() });
  }
  function closePopup() {
    overlay.classList.remove('ssc-popup--open');
    document.body.style.overflow = '';
    if (!getState().subscribed) setState({ dismissed: true });
  }
  function showStatus(html) {
    if (!statusEl) return;
    statusEl.innerHTML = html;
    statusEl.classList.add('ssc-popup-status--visible');
  }

  setTimeout(function() {
    if (window.location.pathname.indexOf('/pages/quiz') !== -1) return;
    var s = getState();
    if (s.subscribed || s.dismissed) return;
    openPopup();
  }, 4000);

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closePopup(); });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('ssc-popup--open')) closePopup();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;

      var btn = form.querySelector('.ssc-popup-submit');
      if (btn) btn.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              list: {
                data: { type: 'list', id: KL_LIST }
              }
            }
          }
        })
      })
      .then(function(response) {
        if (!response.ok) {
          return response.text().then(function(text) {
            console.error('Klaviyo error ' + response.status + ':', text);
            throw new Error(response.status);
          });
        }
        setState({ subscribed: true });
        showStatus('Your guide is on its way — check your inbox!');
        setTimeout(closePopup, 2600);
      })
      .catch(function(err) {
        console.error('Klaviyo submission failed:', err);
        if (btn) btn.disabled = false;
        showStatus('Something went wrong — please try again.');
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-bar"] && !Shopify.designMode) return;
  try {
    
// Duplicate ticker track for seamless loop
(function() {
  var track = document.getElementById('feature-ticker-track');
  if (track && window.innerWidth <= 900) {
    track.innerHTML += track.innerHTML;
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const header = document.getElementById('site-header');
const mobileNav = document.getElementById('mobile-nav');

const isHomepage = document.body.classList.contains('template-index');
const isMobile = () => window.innerWidth <= 1024;
const pillThreshold = isHomepage ? Math.round(window.innerHeight * 0.75) : (isMobile() ? 120 : 10);

let lastScrollY = 0;
window.addEventListener('scroll', () => {
  const current = window.scrollY;
  header?.classList.toggle('is-scrolled', current > pillThreshold);
  if (current > lastScrollY && current > 80) {
    header?.classList.add('site-header--hidden');
  } else {
    header?.classList.remove('site-header--hidden');
  }
  lastScrollY = current;
}, { passive: true });

document.querySelectorAll('[data-menu-toggle]').forEach(btn => {
  btn.addEventListener('click', () => {
    const isOpen = mobileNav.getAttribute('aria-hidden') === 'false';
    mobileNav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    document.body.classList.toggle('drawer-open', !isOpen);
  });
});

document.querySelectorAll('[data-menu-close]').forEach(el => {
  el.addEventListener('click', () => {
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiw-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var dots  = Array.from(document.querySelectorAll('.hiwtl__dot'));
  var cards = Array.from(document.querySelectorAll('.hiwtl__card'));
  var fill  = document.getElementById('hiwtl-line-fill');

  function totalDots() { return dots.length; }

  function setActive(index) {
    // Dots
    dots.forEach(function (d) {
      var active = parseInt(d.dataset.tlIndex, 10) === index;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    // Cards
    cards.forEach(function (c) {
      c.classList.toggle('is-active', parseInt(c.dataset.tlIndex, 10) === index);
    });

    // Progress line fill (percentage through milestones)
    if (fill) {
      var pct = totalDots() <= 1 ? 100 : ((index - 1) / (totalDots() - 1)) * 100;
      fill.style.width = pct + '%';
    }
  }

  // Dot clicks
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      setActive(parseInt(dot.dataset.tlIndex, 10));
    });
  });

  // Card clicks also activate
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      setActive(parseInt(card.dataset.tlIndex, 10));
    });
  });

  // Init line fill for first milestone
  setActive(1);

  // ── Mobile: highlight the card as it scrolls into the center band ──
  var mobileMq = window.matchMedia('(max-width: 768px)');
  var scrollObserver = null;

  function enableScrollHighlight() {
    if (scrollObserver || !cards.length) return;
    scrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive(parseInt(entry.target.dataset.tlIndex, 10));
        }
      });
    }, { threshold: 0, rootMargin: '-45% 0px -45% 0px' });
    cards.forEach(function (card) { scrollObserver.observe(card); });
  }

  function disableScrollHighlight() {
    if (scrollObserver) { scrollObserver.disconnect(); scrollObserver = null; }
  }

  function syncScrollHighlight() {
    if (mobileMq.matches) enableScrollHighlight();
    else disableScrollHighlight();
  }

  syncScrollHighlight();
  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', syncScrollHighlight);
  } else if (mobileMq.addListener) {
    mobileMq.addListener(syncScrollHighlight);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var tiles = document.querySelectorAll('.hiw__tile--img-only');
  if (!tiles.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var tile = entry.target;
      var delay = parseInt(tile.dataset.hiwDelay || 0, 10);
      setTimeout(function () {
        tile.classList.add('hiw--visible');
      }, delay);
      observer.unobserve(tile);
    });
  }, { threshold: 0.15 });

  tiles.forEach(function (tile, i) {
    tile.dataset.hiwDelay = i * 180;
    observer.observe(tile);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('nsl-form');
  if (!form) return;

  var successEl = document.getElementById('nsl-success');
  var errorEl   = document.getElementById('nsl-error');
  var trustEl   = document.getElementById('nsl-trust');

  var KL_COMPANY = 'Rv4p9M';
  var KL_LIST    = 'RaE7KF'; // same list the popup uses = Welcome flow trigger

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var emailInput = document.getElementById('nsl-email');
    var nameInput  = document.getElementById('nsl-name');
    var email      = emailInput ? emailInput.value.trim() : '';
    var firstName  = nameInput ? nameInput.value.trim() : '';

    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (emailInput) emailInput.classList.remove('nsl__input--error');

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (emailInput) emailInput.classList.add('nsl__input--error');
      if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.hidden = false; }
      return;
    }

    var btn = form.querySelector('.nsl__btn');
    if (btn) btn.disabled = true;

    var profileAttrs = { email: email };
    if (firstName) profileAttrs.first_name = firstName;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttrs
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: KL_LIST }
            }
          }
        }
      })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          console.error('Klaviyo error ' + response.status + ':', text);
          throw new Error(response.status);
        });
      }
      form.hidden = true;
      if (trustEl) trustEl.hidden = true;
      if (successEl) successEl.hidden = false;
    })
    .catch(function (err) {
      console.error('Newsletter subscription failed:', err);
      if (btn) btn.disabled = false;
      if (errorEl) { errorEl.textContent = 'Something went wrong — please try again.'; errorEl.hidden = false; }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Scope each column independently — clicking an item only affects siblings in the same column
  document.querySelectorAll('.pdp-faq__col').forEach(function(col) {
    var items = Array.from(col.querySelectorAll('.pdp-faq__item'));

    items.forEach(function(item) {
      var trigger = item.querySelector('.pdp-faq__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');

        // Close all items in THIS column only
        items.forEach(function(i) {
          i.classList.remove('is-open');
          var t = i.querySelector('.pdp-faq__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        // Open the clicked item if it wasn't already open
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hotspot"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var dots      = Array.from(document.querySelectorAll('.pdp-hs__dot'));
  var cards     = Array.from(document.querySelectorAll('.pdp-hs__card'));
  var mobileNav = Array.from(document.querySelectorAll('.pdp-hs__mobile-nav-btn'));
  var totalCards = cards.length;
  var currentIdx = 0;

  if (!dots.length) return;

  function activate(idx) {
    currentIdx = idx;
    dots.forEach(function(d)  { d.classList.remove('is-active'); });
    cards.forEach(function(c) { c.classList.remove('is-active'); });
    mobileNav.forEach(function(b) { b.classList.remove('is-active'); });

    var dot    = dots.find(function(d)  { return parseInt(d.dataset.index) === idx; });
    var card   = cards.find(function(c) { return parseInt(c.dataset.index) === idx; });
    var navBtn = mobileNav.find(function(b) { return parseInt(b.dataset.index) === idx; });

    if (dot)    dot.classList.add('is-active');
    if (card)   card.classList.add('is-active');
    if (navBtn) navBtn.classList.add('is-active');
  }

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { activate(parseInt(this.dataset.index)); });
  });
  cards.forEach(function(card) {
    card.addEventListener('click', function() { activate(parseInt(this.dataset.index)); });
  });
  mobileNav.forEach(function(btn) {
    btn.addEventListener('click', function() { activate(parseInt(this.dataset.index)); });
  });

  // ── Swipe on mobile card area ─────────────────────────────────────────────
  var swipeStartX = null;
  var cardArea = document.querySelector('.pdp-hs__body');
  if (cardArea) {
    cardArea.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
    }, { passive: true });
    cardArea.addEventListener('touchend', function(e) {
      if (swipeStartX === null) return;
      var diff = swipeStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          activate((currentIdx + 1) % totalCards);        // swipe left → next
        } else {
          activate((currentIdx - 1 + totalCards) % totalCards); // swipe right → prev
        }
      }
      swipeStartX = null;
    }, { passive: true });
  }

  // ── Editor drag mode — only inside Shopify customizer ────────────────────
  if (!(window.Shopify && window.Shopify.designMode)) return;

  var imgWrap = document.getElementById('pdp-hs-imgwrap');
  if (!imgWrap) return;

  // Attach persistent coordinate badges to every dot
  dots.forEach(function(dot) {
    dot.style.cursor = 'grab';
    var badge = document.createElement('span');
    badge.className = 'pdp-hs__dot-coords';
    var x = Math.round(parseFloat(dot.style.left));
    var y = Math.round(parseFloat(dot.style.top));
    badge.textContent = 'x:' + x + ' y:' + y;
    dot.appendChild(badge);
  });

  function getBadge(dot) {
    return dot.querySelector('.pdp-hs__dot-coords');
  }

  var dragging = null;

  dots.forEach(function(dot) {
    dot.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      dragging = dot;
      dot.style.cursor   = 'grabbing';
      dot.style.zIndex   = '200';
    });
  });

  document.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    var rect = imgWrap.getBoundingClientRect();
    var x = Math.round(Math.max(5, Math.min(95, (e.clientX - rect.left)  / rect.width  * 100)));
    var y = Math.round(Math.max(5, Math.min(95, (e.clientY - rect.top)   / rect.height * 100)));
    dragging.style.left = x + '%';
    dragging.style.top  = y + '%';
    var badge = getBadge(dragging);
    if (badge) badge.textContent = 'x:' + x + ' y:' + y;
  });

  document.addEventListener('mouseup', function() {
    if (!dragging) return;
    var fx    = Math.round(parseFloat(dragging.style.left));
    var fy    = Math.round(parseFloat(dragging.style.top));
    var badge = getBadge(dragging);
    var text  = 'x: ' + fx + '   y: ' + fy;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
    }

    if (badge) {
      badge.textContent = '✓ Copied!';
      badge.style.background = '#e8948a';
      badge.style.color = '#fff';
      setTimeout(function() {
        badge.textContent = 'x:' + fx + ' y:' + fy;
        badge.style.background = '';
        badge.style.color = '';
      }, 1800);
    }

    dragging.style.cursor = 'grab';
    dragging.style.zIndex = '';
    dragging = null;
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-science"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var items = Array.from(document.querySelectorAll('.pdp-sci__item'));

  items.forEach(function(item) {
    var trigger = item.querySelector('.pdp-sci__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');

      // Close all
      items.forEach(function(i) {
        i.classList.remove('is-open');
        var t = i.querySelector('.pdp-sci__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });

      // If it wasn't open, open it
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var variants = window.__pdpVariants || [];
  var selectedOptions = [];

  document.querySelectorAll('.pdp__opt-btn--active').forEach(function(btn) {
    selectedOptions[parseInt(btn.dataset.optionIndex)] = btn.dataset.value;
  });

  document.querySelectorAll('.pdp__opt-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = parseInt(this.dataset.optionIndex);
      selectedOptions[idx] = this.dataset.value;
      document.querySelectorAll('.pdp__opt-btn[data-option-index="' + idx + '"]').forEach(function(b) {
        b.classList.remove('pdp__opt-btn--active');
      });
      this.classList.add('pdp__opt-btn--active');
      var label = document.querySelector('.pdp__option-val[data-option="' + idx + '"]');
      if (label) label.textContent = this.dataset.value;
      var variant = findVariant(selectedOptions);
      if (variant) updateVariant(variant);
    });
  });

  function findVariant(opts) {
    return variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return !opts[i] || opt === opts[i];
      });
    });
  }

  function formatMoney(cents) {
    return 'R ' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateVariant(v) {
    var variantInput = document.getElementById('pdp-variant-id');
    if (variantInput) variantInput.value = v.id;
    var formattedPrice = formatMoney(v.price);
    var priceEl = document.getElementById('pdp-price');
    var stickyPrice = document.getElementById('pdp-sticky-price');
    if (priceEl) priceEl.textContent = formattedPrice;
    if (stickyPrice) stickyPrice.textContent = formattedPrice;
    var compareEl = document.getElementById('pdp-compare');
    var saveEl = document.getElementById('pdp-save');
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.style.display = '';
        if (saveEl) {
          saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          saveEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }
    var atcBtn = document.getElementById('pdp-atc');
    var atcText = document.getElementById('pdp-atc-text');
    if (atcBtn && atcText) {
      if (v.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('pdp__atc--sold-out');
        atcText.textContent = 'Add to Cart';
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('pdp__atc--sold-out');
        atcText.textContent = 'Sold Out';
      }
    }
  }

  var qtyInput = document.getElementById('pdp-qty');
  document.getElementById('pdp-qty-minus') && document.getElementById('pdp-qty-minus').addEventListener('click', function() {
    if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
  });
  document.getElementById('pdp-qty-plus') && document.getElementById('pdp-qty-plus').addEventListener('click', function() {
    if (qtyInput) qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
  });

  // ── Bundle selector — synced with qty stepper ──
  var bundleBtns = document.querySelectorAll('.pdp__bundle');
  var priceEl    = document.getElementById('pdp-price');
  var compareEl  = document.getElementById('pdp-compare');
  var saveEl     = document.getElementById('pdp-save');
  var singleDisplayPrice = priceEl ? priceEl.textContent : '';
  var singleCompare      = compareEl ? compareEl.textContent : '';
  var singleSave         = saveEl    ? saveEl.textContent    : '';

  // Build qty → bundle price map from card data attributes
  var bundlePriceMap = {};
  bundleBtns.forEach(function(btn) {
    bundlePriceMap[parseInt(btn.dataset.qty)] = btn.dataset.displayPrice;
  });

  function updateBundleState(qty) {
    // Sync card highlight
    bundleBtns.forEach(function(b) { b.classList.remove('pdp__bundle--active'); });
    var activeCard = document.querySelector('.pdp__bundle[data-qty="' + qty + '"]');
    if (activeCard) activeCard.classList.add('pdp__bundle--active');

    // Sync price display
    if (qty > 1 && bundlePriceMap[qty]) {
      if (priceEl) priceEl.textContent = bundlePriceMap[qty];
      // Bundle-specific compare price (strikethrough)
      if (compareEl) {
        var orig = activeCard ? activeCard.dataset.originalPrice : '';
        if (orig) { compareEl.textContent = orig; compareEl.style.display = ''; }
        else      { compareEl.style.display = 'none'; }
      }
      // Bundle-specific save badge
      if (saveEl) {
        var badge = activeCard ? activeCard.dataset.saveBadge : '';
        if (badge) { saveEl.textContent = badge; saveEl.style.display = ''; }
        else       { saveEl.style.display = 'none'; }
      }
    } else {
      // Restore single-product pricing
      if (priceEl) priceEl.textContent = singleDisplayPrice;
      if (compareEl) {
        if (singleCompare) { compareEl.textContent = singleCompare; compareEl.style.display = ''; }
        else               { compareEl.style.display = 'none'; }
      }
      if (saveEl) {
        if (singleSave) { saveEl.textContent = singleSave; saveEl.style.display = ''; }
        else            { saveEl.style.display = 'none'; }
      }
    }
  }

  // Clicking a bundle card sets qty + updates state
  bundleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var qty = parseInt(this.dataset.qty);
      if (qtyInput) qtyInput.value = qty;
      updateBundleState(qty);

      // Auto add-to-cart + open cart drawer on bundle selection
      var pdpForm = document.querySelector('.pdp__form');
      if (pdpForm) {
        if (pdpForm.requestSubmit) { pdpForm.requestSubmit(); }
        else { pdpForm.submit(); }
      }
    });
  });

  // Wrap qty stepper to also trigger bundle state
  var origMinus = document.getElementById('pdp-qty-minus');
  var origPlus  = document.getElementById('pdp-qty-plus');
  if (origMinus) origMinus.addEventListener('click', function() {
    setTimeout(function() { updateBundleState(parseInt(qtyInput ? qtyInput.value : 1)); }, 0);
  });
  if (origPlus) origPlus.addEventListener('click', function() {
    setTimeout(function() { updateBundleState(parseInt(qtyInput ? qtyInput.value : 1)); }, 0);
  });

  document.querySelectorAll('.pdp__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('pdp-main-img');
      if (!mainImg) return;

      var newSrc    = this.dataset.full;
      var newSrcset = this.dataset.srcset || '';
      var newAlt    = this.dataset.alt || '';

      // Already showing this image — do nothing
      var normCurrent = (mainImg.src || '').replace(/^https?:/, '');
      var normNew     = (newSrc || '').replace(/^https?:/, '');
      if (normCurrent.split('?')[0] === normNew.split('?')[0]) return;

      // Update active thumb immediately
      document.querySelectorAll('.pdp__thumb').forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
      this.classList.add('pdp__thumb--active');

      // Fade out instantly, swap src straight away — don't wait for preload
      mainImg.style.opacity = '0';

      // Clear any previous onload to avoid stale callbacks
      mainImg.onload = null;

      setTimeout(function() {
        // Swap src immediately so the browser starts fetching the new image
        mainImg.removeAttribute('srcset');
        mainImg.src = newSrc;
        if (newSrcset) mainImg.srcset = newSrcset;
        if (newAlt) mainImg.alt = newAlt;

        // Fade back in once the new image is decoded and ready
        mainImg.onload = function() {
          mainImg.onload = null;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              mainImg.style.opacity = '1';
            });
          });
        };

        // Safety fallback — fade in regardless after 1.5s in case onload misfires
        setTimeout(function() { mainImg.style.opacity = '1'; }, 1500);
      }, 120);
    });
  });

  // ── Swipeable main image carousel (mobile touch) ──
  var mainWrap = document.querySelector('.pdp__main-wrap');
  var thumbEls = Array.prototype.slice.call(document.querySelectorAll('.pdp__thumb'));
  if (mainWrap && thumbEls.length > 1) {
    var touchStartX = 0, touchStartY = 0, touchDeltaX = 0, touchDeltaY = 0;

    function activeThumbIndex() {
      return thumbEls.findIndex(function(t) { return t.classList.contains('pdp__thumb--active'); });
    }

    mainWrap.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      touchDeltaY = 0;
    }, { passive: true });

    mainWrap.addEventListener('touchmove', function(e) {
      touchDeltaX = e.touches[0].clientX - touchStartX;
      touchDeltaY = e.touches[0].clientY - touchStartY;
    }, { passive: true });

    mainWrap.addEventListener('touchend', function() {
      var threshold = 40;
      if (Math.abs(touchDeltaX) > threshold && Math.abs(touchDeltaX) > Math.abs(touchDeltaY)) {
        var idx = activeThumbIndex();
        var nextIdx = touchDeltaX < 0 ? idx + 1 : idx - 1;
        if (nextIdx >= 0 && nextIdx < thumbEls.length) {
          thumbEls[nextIdx].click();
        }
      }
      touchDeltaX = 0;
      touchDeltaY = 0;
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-funnel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('quiz');
  if (!root) return;

  var stage      = root.querySelector('[data-quiz-stage]');
  var steps      = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
  var topbar     = root.querySelector('[data-quiz-topbar]');
  var qlabel     = root.querySelector('[data-quiz-qlabel]');
  var progressBar = root.querySelector('[data-quiz-progress-bar]');
  var nav        = root.querySelector('[data-quiz-nav]');
  var backBtn    = root.querySelector('[data-quiz-back]');
  var nextBtn    = root.querySelector('[data-quiz-next]');
  var startBtn   = root.querySelector('[data-quiz-start]');
  var form       = root.querySelector('#quiz-form');

  var order = ['intro', 'q-concern', 'q-age', 'q-time', 'q-experience', 'q-objection', 'q-emotion', 'capture', 'results'];
  var questionSteps = order.filter(function (s) { return s.indexOf('q-') === 0; });
  var current = 0;
  var answers = {};
  var autoAdvTimer;

  function stepEl(name) {
    return steps.filter(function (s) { return s.dataset.quizStep === name; })[0];
  }

  function goTo(name) {
    current = order.indexOf(name);
    steps.forEach(function (s) {
      s.classList.toggle('quiz__step--active', s.dataset.quizStep === name);
    });

    var isQuestion = name.indexOf('q-') === 0;
    var isCapture = name === 'capture';
    var isResults = name === 'results';

    topbar.hidden = !(isQuestion || isCapture || isResults);
    nav.hidden = !(isQuestion || isCapture);
    nextBtn.hidden = isCapture;

    if (isQuestion) {
      var qIdx = questionSteps.indexOf(name);
      qlabel.textContent = 'Question ' + (qIdx + 1) + ' of ' + questionSteps.length;
      progressBar.style.width = (((qIdx + 1) / questionSteps.length) * 100) + '%';
      nextBtn.disabled = !answers[stepEl(name).dataset.question];
    } else if (isCapture) {
      qlabel.textContent = 'Almost Done';
      progressBar.style.width = '100%';
    } else if (isResults) {
      qlabel.textContent = 'Your Results';
      progressBar.style.width = '100%';
    }

    window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
  }

  startBtn.addEventListener('click', function () { goTo(questionSteps[0]); });

  backBtn.addEventListener('click', function () {
    var name = order[current];
    if (name === 'capture') {
      goTo(questionSteps[questionSteps.length - 1]);
      return;
    }
    var qIdx = questionSteps.indexOf(name);
    if (qIdx > 0) {
      goTo(questionSteps[qIdx - 1]);
    } else {
      goTo('intro');
    }
  });

  nextBtn.addEventListener('click', function () {
    var name = order[current];
    if (name.indexOf('q-') !== 0) return;
    var question = stepEl(name).dataset.question;
    if (!answers[question]) return;
    var qIdx = questionSteps.indexOf(name);
    if (qIdx < questionSteps.length - 1) {
      goTo(questionSteps[qIdx + 1]);
    } else {
      goTo('capture');
    }
  });

  questionSteps.forEach(function (name) {
    var step = stepEl(name);
    var question = step.dataset.question;
    var isLast = name === questionSteps[questionSteps.length - 1];
    step.querySelectorAll('.quiz__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        step.querySelectorAll('.quiz__option').forEach(function (b) { b.classList.remove('quiz__option--selected'); });
        btn.classList.add('quiz__option--selected');
        answers[question] = btn.dataset.value;
        if (order[current] === name) {
          nextBtn.disabled = false;
          clearTimeout(autoAdvTimer);
          autoAdvTimer = setTimeout(function () {
            if (isLast) {
              goTo('capture');
            } else {
              var qIdx = questionSteps.indexOf(name);
              goTo(questionSteps[qIdx + 1]);
            }
          }, 320);
        }
      });
    });
  });

  // ── Content library — small set of copy blocks recombined per answer ──
  var LIB = {
    emotionHeadline: {
      lift:       'Your Skin Wants To Feel Lifted Again.',
      smooth:     'Smoother, Fresher Skin Starts Here.',
      confidence: 'Real Confidence, Bare-Faced.',
      ritual:     "A Simple Ritual That's Entirely Yours."
    },
    concern: {
      jawline:    { sub: "You told us jawline definition and sagging are your biggest concern. Here's exactly how the Microcurrent Device helps.", whyTitle: 'Built To Lift & Define Your Jawline' },
      fine_lines: { sub: "You told us fine lines and wrinkles are your biggest concern. Here's exactly how the Microcurrent Device helps.", whyTitle: 'Built To Soften Fine Lines & Wrinkles' },
      dullness:   { sub: "You told us dullness and uneven tone are your biggest concern. Here's exactly how the Microcurrent Device helps.", whyTitle: 'Built To Restore Glow & Even Tone' },
      all:        { sub: "You told us it's a bit of everything. Here's exactly how the Microcurrent Device helps, all in one routine.", whyTitle: 'Built For All-Round Skin Renewal' }
    },
    timeBullet: {
      under2:  'Fits into under 2 minutes, clip it onto a routine you already have.',
      about5:  'A simple 5-minute ritual, most mornings before the rest of your routine.',
      tenplus: "Room to make it a proper ritual. Most women glide through a full routine in under 10 minutes.",
      depends: 'Flexes with your day, use it for 2 minutes or 10, whatever you have time for.'
    },
    experienceBullet: {
      never:   'No experience needed. A guided glide pattern along your jawline and cheekbones is all it takes.',
      creams:  'Goes further than creams and serums by actively stimulating the muscle, not just the surface.',
      facials: 'Clinic-grade microcurrent, at home, for a fraction of what regular facials cost over time.',
      device:  "If you've used a device before, you'll notice the V-shaped head reaches the jawline and neck more precisely."
    },
    testimonial: {
      '30s': { quote: 'Starting this in my 30s is the best skin decision I\'ve ever made.', name: 'Micaela H., Age 31 · Cape Town' },
      '40s': { quote: 'Six weeks in and my jawline is back. I genuinely didn\'t think this was possible.', name: 'Wilmé B., Age 47 · Johannesburg' },
      '50s': { quote: 'Three months in. My skin looks younger than it did at 42.', name: 'Riekie S., Age 55 · Bloemfontein' },
      '60s': { quote: 'Firmer in 30 days. My friends thought I\'d had something done.', name: 'Corrie R., Age 63 · Pretoria' }
    },
    objection: {
      gentle:    { title: 'Completely non-invasive — by design.', text: 'Microcurrent mimics your skin\'s own natural bioelectrical frequency. No heat, no needles, no harsh chemicals. Just gentle stimulation that works with your skin, not against it.' },
      education: { title: 'Here\'s the short version of the science.', text: 'Microcurrent sends tiny electrical signals into the facial muscles, encouraging them to lift and tone — the same technology used in professional clinics, now at home for a fraction of the cost.' },
      easy:      { title: 'Three gliding motions. That\'s it.', text: 'A simple upward glide along your jawline, cheekbones and brow. Most women have it down within the first session — no training, no complicated steps.' },
      social:    { title: "Don't just take our word for it.", text: 'Thousands of women across South Africa have already made the switch. Scroll down to see real results from real customers — women just like you.' }
    }
  };

  function buildResults() {
    var emotion   = answers.emotion || 'lift';
    var concern   = answers.concern || 'all';
    var time      = answers.time || 'about5';
    var experience = answers.experience || 'never';
    var objection = answers.objection || 'education';
    var age       = answers.age || 'unsure';

    var concernData = LIB.concern[concern];
    var testimonialData = LIB.testimonial[age] || LIB.testimonial['40s'];
    var objectionData = LIB.objection[objection];

    root.querySelector('[data-quiz-headline]').textContent = LIB.emotionHeadline[emotion];
    root.querySelector('[data-quiz-sub]').textContent = concernData.sub;
    root.querySelector('[data-quiz-why-title]').textContent = concernData.whyTitle;

    var bulletsEl = root.querySelector('[data-quiz-bullets]');
    bulletsEl.innerHTML = '';
    [LIB.timeBullet[time], LIB.experienceBullet[experience]].forEach(function (text) {
      var li = document.createElement('li');
      li.textContent = text;
      bulletsEl.appendChild(li);
    });

    root.querySelector('[data-quiz-testimonial]').textContent = testimonialData.quote;
    root.querySelector('[data-quiz-testimonial-name]').textContent = testimonialData.name;

    root.querySelector('[data-quiz-objection-title]').textContent = objectionData.title;
    root.querySelector('[data-quiz-objection-text]').textContent = objectionData.text;
  }

  if (form) {
    function handleCapture(e) {
      if (e) e.preventDefault();

      var firstNameField = document.getElementById('quiz-firstname');
      var emailField     = document.getElementById('quiz-email');
      var errorEl        = form.querySelector('[data-quiz-error]');

      var firstName = firstNameField ? firstNameField.value.trim() : '';
      var email     = emailField ? emailField.value.trim() : '';

      if (!firstName || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) errorEl.style.display = 'block';
        return;
      }
      if (errorEl) errorEl.style.display = 'none';

      // Show results immediately — don't make the UI wait on the network
      buildResults();
      goTo('results');

      // Suppress popup for this browser — quiz completers skip the popup
      try { localStorage.setItem('sk_quiz_done', '1'); } catch (err) {}

      // Submit to Klaviyo with quiz answers as profile properties
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Rv4p9M', {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: firstName,
                    properties: {
                      quiz_concern:    answers.concern    || '',
                      quiz_age:        answers.age        || '',
                      quiz_time:       answers.time       || '',
                      quiz_experience: answers.experience || '',
                      quiz_objection:  answers.objection  || '',
                      quiz_emotion:    answers.emotion    || ''
                    }
                  }
                }
              },
              list_id: 'TC8hYM'
            }
          }
        })
      }).catch(function () {});
    }

    form.addEventListener('submit', handleCapture);
    var submitBtn = form.querySelector('[data-quiz-submit]');
    if (submitBtn) submitBtn.addEventListener('click', handleCapture);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.getElementById('rrev-grid');
  var dotsEl = document.getElementById('rrev-dots');
  if (!grid || !dotsEl) return;

  var cards = Array.from(grid.querySelectorAll('.rrev__card'));
  if (!cards.length) return;

  // Build dots
  cards.forEach(function (_, i) {
    var dot = document.createElement('span');
    dot.className = 'rrev__dot' + (i === 0 ? ' is-active' : '');
    dotsEl.appendChild(dot);
  });

  var dots = Array.from(dotsEl.querySelectorAll('.rrev__dot'));

  function updateDots() {
    var scrollLeft = grid.scrollLeft;
    var cardWidth = cards[0].offsetWidth + 14; // card + gap
    var active = Math.round(scrollLeft / cardWidth);
    active = Math.max(0, Math.min(active, dots.length - 1));
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === active);
    });
  }

  grid.addEventListener('scroll', updateDots, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.rcar__row').forEach(function (row) {
    var track = row.querySelector('.rcar__track');
    if (!track) return;

    var isRight = track.classList.contains('rcar__track--right');

    function halfW()   { return track.scrollWidth / 2; }
    function getAnim() { return track.getAnimations()[0]; }
    function getDur(a) { return a.effect.getTiming().duration || 40000; }

    var active    = false;
    var confirmed = false;
    var sx = 0, sy = 0;
    var startTime = 0, startDur = 1;

    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      active    = true;
      confirmed = false;
      sx = e.clientX;
      sy = e.clientY;
    }, { passive: true });

    window.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dx = e.clientX - sx;
      var dy = e.clientY - sy;

      if (!confirmed) {
        /* Wait for a clear horizontal intent before freezing the animation */
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dy) > Math.abs(dx)) { active = false; return; } /* vertical scroll — leave it alone */

        /* Horizontal confirmed — pause the CSS animation right now */
        var anim = getAnim();
        if (!anim) { active = false; return; }

        startTime = anim.currentTime || 0;
        startDur  = getDur(anim);
        anim.pause();

        sx        = e.clientX; /* reset origin so dx starts from 0 */
        confirmed = true;
        row.classList.add('is-dragging');
        return;
      }

      /* Seek the animation to wherever the finger is */
      var h  = halfW();
      var dt = (isRight ? dx : -dx) * startDur / h;
      var t  = ((startTime + dt) % startDur + startDur) % startDur;

      var anim = getAnim();
      if (anim) anim.currentTime = t;

    }, { passive: true });

    function end() {
      if (!active) return;
      active = false; confirmed = false;
      row.classList.remove('is-dragging');
      var anim = getAnim();
      if (anim && anim.playState === 'paused') anim.play();
    }

    window.addEventListener('pointerup',     end, { passive: true });
    window.addEventListener('pointercancel', end, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science"] && !Shopify.designMode) return;
  try {
    
(function () {

  var statsBlock = document.querySelector('[data-sci-stats]');
  if (!statsBlock) return;

  var triggered = false;

  function animateStat(el) {
    var target   = parseFloat(el.dataset.target);
    var suffix   = el.dataset.suffix || '';
    var prefix   = el.dataset.prefix || '';
    var duration = 1800;
    var startTs  = null;

    function tick(ts) {
      if (!startTs) startTs = ts;
      var elapsed  = ts - startTs;
      var progress = Math.min(elapsed / duration, 1);
      // Ease-out cubic
      var ease = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(ease * target);

      // Format 12000 → R12K, 50000 → 50K+
      if (target >= 1000) {
        el.textContent = prefix + Math.round(ease * (target / 1000)) + 'K' + suffix;
      } else {
        el.textContent = prefix + value + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = prefix + (target >= 1000
          ? Math.round(target / 1000) + 'K'
          : target) + suffix;
      }
    }

    requestAnimationFrame(tick);
  }

  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting && !triggered) {
      triggered = true;
      statsBlock.querySelectorAll('[data-target]').forEach(animateStat);
    }
  }, { threshold: 0.35 });

  observer.observe(statsBlock);

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-concern"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pills  = Array.from(document.querySelectorAll('.skc__pill'));
  var panels = Array.from(document.querySelectorAll('.skc__panel'));

  if (!pills.length) return;

  function activate(idx) {
    pills.forEach(function (p, i) {
      p.classList.toggle('skc__pill--active', i === idx);
      p.setAttribute('aria-selected', i === idx ? 'true' : 'false');
    });
    panels.forEach(function (p, i) {
      p.classList.toggle('skc__panel--active', i === idx);
    });
  }

  pills.forEach(function (pill, i) {
    pill.addEventListener('click', function () { activate(i); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track    = document.querySelector('[data-tst-track]');
  var wrap     = track ? track.parentElement : null;
  var prevBtn  = document.querySelector('[data-tst-prev]');
  var nextBtn  = document.querySelector('[data-tst-next]');
  var dotsWrap = document.querySelector('[data-tst-dots]');
  if (!track || !wrap || !prevBtn || !nextBtn) return;

  var cards   = Array.from(track.children);
  var total   = cards.length;
  var current = 0;
  var dots    = [];
  var mq      = window.matchMedia('(max-width: 768px)');
  var goTo    = function () {};

  function buildDots(count) {
    dotsWrap.innerHTML = '';
    dots = [];
    for (var i = 0; i < count; i++) {
      var d = document.createElement('button');
      d.className = 'tst__dot' + (i === 0 ? ' tst__dot--active' : '');
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.dataset.idx = String(i);
      d.addEventListener('click', function () { goTo(parseInt(this.dataset.idx, 10)); });
      dotsWrap.appendChild(d);
      dots.push(d);
    }
  }

  function setDot(idx) {
    current = idx;
    dots.forEach(function (d, i) { d.classList.toggle('tst__dot--active', i === idx); });
  }

  /* ── Mobile: native CSS scroll-snap ── */
  function initMobile() {
    buildDots(total);
    track.style.transform = '';

    function stepWidth() {
      /* actual distance from one card's left edge to the next */
      if (cards.length > 1) {
        return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      }
      return cards[0] ? cards[0].offsetWidth + 16 : 300;
    }

    goTo = function (idx) {
      idx = Math.max(0, Math.min(idx, total - 1));
      wrap.scrollTo({ left: idx * stepWidth(), behavior: 'smooth' });
      setDot(idx);
    };

    prevBtn.onclick = function () { goTo(current - 1); };
    nextBtn.onclick = function () { goTo(current + 1); };

    /* Sync dot from native scroll position */
    var scrollTimer;
    wrap.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var sw = stepWidth();
        if (!sw) return;
        var idx = Math.round(wrap.scrollLeft / sw);
        setDot(Math.max(0, Math.min(idx, total - 1)));
      }, 60);
    }, { passive: true });
  }

  /* ── Desktop: JS transform paging (3-up) ── */
  function initDesktop() {
    var perPage = 3;
    var pages   = Math.ceil(total / perPage);
    buildDots(pages);

    goTo = function (idx) {
      idx = Math.max(0, Math.min(idx, pages - 1));
      var cw  = cards[0] ? cards[0].offsetWidth : 0;
      var gap = 20;
      track.style.transform = 'translateX(-' + (idx * perPage * (cw + gap)) + 'px)';
      setDot(idx);
    };

    prevBtn.onclick = function () { goTo(current - 1); };
    nextBtn.onclick = function () { goTo(current + 1); };

    /* Mouse drag */
    var startX = 0, dragging = false;
    track.addEventListener('mousedown',  function (e) { dragging = true; startX = e.clientX; track.style.cursor = 'grabbing'; });
    track.addEventListener('mouseup',    function (e) {
      if (!dragging) return;
      dragging = false; track.style.cursor = 'grab';
      var d = startX - e.clientX;
      if (d > 60) goTo(current + 1);
      else if (d < -60) goTo(current - 1);
    });
    track.addEventListener('mouseleave', function () { dragging = false; track.style.cursor = 'grab'; });
  }

  /* ── Init ── */
  if (mq.matches) { initMobile(); } else { initDesktop(); }

  mq.addEventListener('change', function () {
    current = 0;
    track.style.transform = '';
    if (mq.matches) { wrap.scrollLeft = 0; initMobile(); } else { initDesktop(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
